/** Expedition 1 survival window. Nav + Meet Sam use this one clock.
 * Launch epoch: 2026-09-04 14:30 IST = 2026-09-04T09:00:00.000Z
 * Deadline = epoch + 60 days = 2026-11-03T09:00:00.000Z
 */
export const SURVIVAL_DEADLINE_MS = Date.parse("2026-11-03T09:00:00.000Z");

const pad = (n) => String(n).padStart(2, "0");

export const remainingParts = (now = Date.now()) => {
  const totalSeconds = Math.max(
    0,
    Math.floor((SURVIVAL_DEADLINE_MS - now) / 1000)
  );
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { totalSeconds, days, hours, minutes, seconds };
};

/** Compact nav label: total hours:minutes */
export const compactCountdown = (now = Date.now()) => {
  const { days, hours, minutes } = remainingParts(now);
  const hh = days * 24 + hours;
  return `${String(hh).padStart(2, "0")}:${pad(minutes)}`;
};

/** Meet Sam label: Nd HH:MM:SS */
export const longCountdown = (now = Date.now()) => {
  const { days, hours, minutes, seconds } = remainingParts(now);
  return `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

/** Shortest nav label for <sm: Nd HH:MM (e.g. "59d 04:18") */
export const shortCountdown = (now = Date.now()) => {
  const { days, hours, minutes } = remainingParts(now);
  return `${days}d ${pad(hours)}:${pad(minutes)}`;
};
